// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/impact-icing.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/impact-icing/impact-icing.js';

mount([g0]);
